/**
 * Game Configuration
 * Contains metadata for all 7 games in RageBaitStudio
 */

export const GAMES = {
  TICTACTOE: {
    id: 'tictactoe',
    name: 'Tic Tac Toe',
    displayName: 'Tic Tac Toe',
    icon: '✖️⭕',
    emoji: '⭕',
    description: 'Classic 3×3 grid - Get three in a row!',
    complexity: 1, // 1-5 scale
    duration: '1-2 min',
    players: 2,
    color: '#4CAF50',
    gradient: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
    implemented: true,
  },
  CONNECT4: {
    id: 'connect4',
    name: 'connect4',
    displayName: 'Connect 4',
    icon: '🔴🟡',
    emoji: '🔴',
    description: 'Drop discs and connect four in a row!',
    complexity: 2,
    duration: '3-10 min',
    players: 2,
    color: '#FF9800',
    gradient: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
    implemented: true,
  },
  RPS: {
    id: 'rps',
    name: 'rockpaperscissors',
    displayName: 'Rock Paper Scissors',
    icon: '✊✋✌️',
    emoji: '✊',
    description: 'Best of 5 - Classic hand game!',
    complexity: 1,
    duration: '2-5 min',
    players: 2,
    color: '#9C27B0',
    gradient: 'linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%)',
    implemented: true,
  },
  DOTSANDBOXES: {
    id: 'dotsandboxes',
    name: 'dotsandboxes',
    displayName: 'Dots & Boxes',
    icon: '📦🖊️',
    emoji: '📦',
    description: 'Connect dots and claim boxes!',
    complexity: 2,
    duration: '5-15 min',
    players: 2,
    color: '#2196F3',
    gradient: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
    implemented: true,
  },
  AMERICAN_CHECKERS: {
    id: 'americancheckers',
    name: 'americancheckers',
    displayName: 'American Checkers',
    icon: '🔴⚫',
    emoji: '⚫',
    description: 'Classic checkers - Jump and capture to victory!',
    complexity: 3,
    duration: '10-30 min',
    players: 2,
    color: '#E91E63',
    gradient: 'linear-gradient(135deg, #E91E63 0%, #C2185B 100%)',
    implemented: true,
  },
  RUSSIAN_CHECKERS: {
    id: 'russiancheckers',
    name: 'russiancheckers',
    displayName: 'Russian Checkers',
    icon: '⚫⚪',
    emoji: '⚪',
    description: 'Flying kings & backward captures - More tactical!',
    complexity: 4,
    duration: '15-40 min',
    players: 2,
    color: '#9C27B0',
    gradient: 'linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%)',
    implemented: true,
  },
  BATTLESHIP: {
    id: 'battleship',
    name: 'battleship',
    displayName: 'Battleship',
    icon: '⚓🎯',
    emoji: '⚓',
    description: 'Sink your opponent\'s fleet!',
    complexity: 3,
    duration: '15-30 min',
    players: 2,
    color: '#00BCD4',
    gradient: 'linear-gradient(135deg, #00BCD4 0%, #0097A7 100%)',
    implemented: true,
  },
  CHESS: {
    id: 'chess',
    name: 'chess',
    displayName: 'Chess',
    icon: '♟️👑',
    emoji: '♟️',
    description: 'The ultimate strategy game!',
    complexity: 5,
    duration: '30-60 min',
    players: 2,
    color: '#607D8B',
    gradient: 'linear-gradient(135deg, #607D8B 0%, #455A64 100%)',
    implemented: true,
  },
};

/**
 * Get all games as an array
 */
export const getAllGames = () => {
  return Object.values(GAMES);
};

/**
 * Get game by ID
 */
export const getGameById = (gameId) => {
  return Object.values(GAMES).find(game => game.id === gameId) || null;
};

/**
 * Get games sorted by complexity
 */
export const getGamesByComplexity = () => {
  return getAllGames().sort((a, b) => a.complexity - b.complexity);
};

/**
 * Get games sorted by duration
 */
export const getGamesByDuration = () => {
  const durationOrder = {
    '1-2 min': 1,
    '2-5 min': 2,
    '3-10 min': 3,
    '5-15 min': 4,
    '10-30 min': 5,
    '15-30 min': 6,
    '30-60 min': 7,
  };

  return getAllGames().sort((a, b) => {
    return durationOrder[a.duration] - durationOrder[b.duration];
  });
};
